/** Who a suspension stops: a person, or a business (`Organization`). */
export enum SuspensionSubject {
  USER = "user",
  ORGANIZATION = "organization",
}

/**
 * What a suspension stops. `account` is all of it: a person cannot sign in, a business has nothing
 * public and can start nothing new.
 */
export enum SuspensionScope {
  ACCOUNT = "account",
  /** Writing comments on the blog. */
  COMMENTS = "comments",
  /** Taking a seat at an event. */
  EVENT_SIGNUP = "event_signup",
  /** Booking a session. */
  BOOKING = "booking",
  /** Creating and editing events. On a business, its events also leave every public list. */
  EVENTS = "events",
  /** Editing or publishing a business page. On a business, the page goes offline too. */
  PAGE = "page",
  /** Creating and editing services, offers and products. On a business, nothing of it can be bought. */
  SELLING = "selling",
  /** Reporting changes to the gym directory and suggesting gyms. Their own gyms keep working. */
  GYM_REPORTS = "gym_reports",
}

/** The scopes that mean something for each subject. A business never signs up or books. */
export const SUSPENSION_SCOPES: Record<SuspensionSubject, readonly SuspensionScope[]> = {
  [SuspensionSubject.USER]: [
    SuspensionScope.ACCOUNT,
    SuspensionScope.COMMENTS,
    SuspensionScope.EVENT_SIGNUP,
    SuspensionScope.BOOKING,
    SuspensionScope.EVENTS,
    SuspensionScope.PAGE,
    SuspensionScope.SELLING,
    SuspensionScope.GYM_REPORTS,
  ],
  [SuspensionSubject.ORGANIZATION]: [
    SuspensionScope.ACCOUNT,
    SuspensionScope.COMMENTS,
    SuspensionScope.EVENTS,
    SuspensionScope.PAGE,
    SuspensionScope.SELLING,
  ],
};
